import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e2806a9c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://via.placeholder.com/120x120",
  class: "cover"
}, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "product-info-wrapper" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "name text-overflow-2" }, " Break Room Separation - Zero Waste Box™ "),
  /*#__PURE__*/_createElementVNode("div", { class: "info" }, [
    /*#__PURE__*/_createElementVNode("div", null, "size: Small Zero Waste Box 11\" x 11\" x 20\""),
    /*#__PURE__*/_createElementVNode("div", null, "One-time purchase")
  ])
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "price-wrapper" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "price" }, " $ 199.00 "),
  /*#__PURE__*/_createElementVNode("div", { class: "number" }, " x1 ")
], -1))

import { onMounted } from 'vue';

  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  onMounted(() => {});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    to: { name: 'variant.detail', params: { id: 16 } },
    class: "product"
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _hoisted_2,
      _hoisted_3
    ]),
    _: 1
  }, 8, ["to"]))
}
}

})